import React, { useEffect } from 'react';
import api from '../../interceptor/axios';
import { useState } from 'react';
import { useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { Knob } from 'primereact/knob';   
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import { use } from 'react';

const ConfiguradorCallejero = ({ ciudad, onCallejero }) => {

  const toast = useRef(null);
  const [loading, setLoading] = useState(true);
  const [distritos, setDistritos] = useState([]);
  const [barrios, setBarrios] = useState([]);
  const [nombreCiudad, setNombreCiudad] = useState('');
  const [distrito, setDistrito] = useState('T');
  const [barrio, setBarrio] = useState('T');
  const [numCalles, setNumCalles] = useState(10);
  const [tiposCallejero, setTiposCallejero] = useState([
    { nombre: 'Selecciona un tipo de entrenamiento', ID: '' },
    { nombre: 'Mapa mudo', ID: 'mapa' },
    { nombre: 'Preguntas de test', ID: 'test' }  ]);
  const [tipoCallejero, setTipoCallejero] = useState(tiposCallejero[0]);
  const metodosDeCorreccion = [
        { name: 'Selecciona un método de corrección', code: '' },
        { name: '2-1', code: '2-1' },
        { name: '3-1', code: '3-1' },
        { name: '4-1', code: '4-1' }
    ];
  const [metodoCorreccion, setMetodoCorreccion] = useState(metodosDeCorreccion[0]);

  const history = useHistory();   
  

  useEffect(() => {
    api.post(process.env.REACT_APP_REST_URL + '/callejero/configurarCallejero.php', { idCiudad: ciudad.ID })
      .then(response => {
          setLoading(false);
          if(response.data.success !== true){
            toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
          } else {
            let distritosData = response.data.distritos;
            let primerDato = '';
              if(ciudad.tipoMapa == 'CALLEJERO') {
                primerDato = 'Seleccione un distrito';
              } else {
                primerDato = 'Seleccione un área';
              }
            //ponemos uno al principio para que se pueda seleccionar TODOS los distritos
            distritosData.unshift({ nombre: primerDato, ID: 'T' });
            setDistritos(distritosData);
            //para el barrio, solo ponemos uno al principio para que se pueda seleccionar TODOS los barrios
            if(ciudad.tipoMapa == 'CALLEJERO') {
                primerDato = 'Todos los barrios';
              } else {
                primerDato = 'Todos los municipios';
              }
            setBarrios([{ nombre: primerDato, ID: 'T' }]);
            setNombreCiudad(response.data.ciudad.nombre);
         }
      })
      .catch(error => {
         toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
      });
  }, []);

  const volver = () => {
    window.location.href = '/callejero';
  }

  const cambiarDistrito = (distrito) => {
    setDistrito(distrito);
    let primerDato = '';
    if(ciudad.tipoMapa == 'CALLEJERO') {
      primerDato = 'Todos los barrios';
    } else {
      primerDato = 'Todos los municipios';
    }
    if(distrito.ID === 'T') {
      setBarrios([{ nombre: primerDato, ID: 'T' }]);
    } else {
      let barriosData = [...distrito.barrios];
      barriosData.unshift({ nombre: primerDato, ID: 'T' }); 
      setBarrios(barriosData);
    }
  }

  const empezar = () => {
    if(tipoCallejero.ID === '') {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debes seleccionar un tipo de entrenamiento' });
      return;
    }

    let metCorrector = tipoCallejero.ID === 'test' ? metodoCorreccion.code : '';

    let config = {
      ciudad: ciudad.ID,
      distrito: distrito.ID,
      barrio: barrio.ID,
      tipoCallejero: tipoCallejero.ID,
      numCalles: numCalles,
      metodoCorreccion: metCorrector
    };
    
    
    api.post(process.env.REACT_APP_REST_URL + '/callejero/cargarCallejero.php', config)
      .then(response => {
          if(response.data.success !== true){
            toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
          } else {
            if(tipoCallejero.ID === 'mapa') {
              onCallejero(response.data);
            } else {
              let test = response.data.test;
              test.fechaInicio = new Date().getTime();
              sessionStorage.setItem('test', JSON.stringify(test));
              history.push('/test');
            }
         }
      })
      .catch(error => {
         toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
      });
  };

  const quitarCalle = () => {
        if (numCalles > 1){
            setNumCalles(numCalles - 1);
        }
    };

    const addCalle = () => {
        if (numCalles < 100){
            setNumCalles(numCalles + 1);
        }
    };

  if(loading) {
    return (
      <>
      <Toast ref={toast} />
      <div className="skeleton-temario">
        <section id="iq-favorites">
          <div className="d-flex align-items-center justify-content-center">
            <h2>Cargando configurador de callejero...</h2>
          </div>
        </section>
      </div>
      </>
    );
  } else {

    return (
      <>
      <Toast ref={toast} />

      <h2>Configurando callejero para: {nombreCiudad}</h2>
      <button type='button' className='btn btn-hover iq-button mt-2 mb-2 col-12 col-lg-2 offset-lg-1' onClick={volver}><i className="fa fa-bars mr-1" aria-hidden="true"></i>Volver</button>
      <div className="row">
        <div className="col-12 col-lg-4">
          <div className='form-group'>
              <h5 className="main-title">
                {ciudad.tipoMapa == 'CALLEJERO' ? '¿Qué distrito quieres entrenar?' : '¿Qué área quieres entrenar?'}
              </h5>
              <Dropdown value={distrito} onChange={(e) => cambiarDistrito(e.value)} options={distritos} optionLabel="nombre" 
                  placeholder={ciudad.tipoMapa == 'CALLEJERO' ? 'Seleccione un distrito' : 'Seleccione un área'} className="w-100 mt-4 mb-4" />
          </div>
          <div className='form-group'>
              <h5 className="main-title">
                {ciudad.tipoMapa == 'CALLEJERO' ? '¿Qué barrio quieres entrenar?' : '¿Qué municipio?'}
                
                </h5>
              <Dropdown value={barrio} onChange={(e) => setBarrio(e.value)} options={barrios} optionLabel="nombre" 
                  placeholder={ciudad.tipoMapa == 'CALLEJERO' ? 'Seleccione un barrio' : 'Seleccione un municipio'} className="w-100 mt-4 mb-4" />
          </div>
          <div className='form-group'>
            <h5 className="main-title">
              {ciudad.tipoMapa == 'CALLEJERO' ? '¿Cuántas calles quieres entrenar?' : '¿Cuántas carreteras quieres entrenar?'}
            </h5>
            <div>
                <Knob value={numCalles} onChange={(e) => setNumCalles(e.value)} min={1} max={100} step={1} valueColor='#e50914'/>
                <Button icon="pi pi-minus" className='mr-1 boton-primario' onClick={quitarCalle} />   
                <Button icon="pi pi-plus" className='ml-1 boton-primario' onClick={addCalle} />
              </div>
          </div>
        </div>   
        <div className="col-12 col-lg-8">
            <h5 className="main-title">¿Qué tipo de entrenamiento quieres?</h5>
            <Dropdown value={tipoCallejero} onChange={(e) => setTipoCallejero(e.value)} options={tiposCallejero} optionLabel="nombre" 
                    placeholder='Seleccione un barrio' className="w-100 mt-4 mb-4" />
            
            {tipoCallejero.ID === 'test' && (
            <div>
              <h5 className="main-title">Método de corrección</h5>
              <Dropdown value={metodoCorreccion} onChange={(e) => setMetodoCorreccion(e.value)} options={metodosDeCorreccion} optionLabel="name" 
                    placeholder="Selecciona un método de corrección" className="w-100 mt-4 mb-4" />
            </div>
            )}
            <button type='button' className='btn btn-hover iq-button mt-2 mb-2' onClick={empezar}><i className="fa fa-bars mr-1" aria-hidden="true"></i>Comenzar</button>
          </div>
        </div>     
      </>
    );
  }
};

export default ConfiguradorCallejero;
